
import isEmpty from 'lodash/isEmpty'

import ColorSwatches from './ColorSwatches.vue'
import translations from './ProductCard.translations'
import StorageTags from './StorageTags.vue'

export default {
  components: {
    ColorSwatches,
    StorageTags,
  },
  props: {
    attributes: { type: Array, default: () => [] },
    storages: { type: Array, default: () => [] },
    colors: { type: Array, default: () => [] },
  },
  computed: {
    translations: () => translations,
    displayStorages() {
      return !isEmpty(this.storages)
    },
    displayColors() {
      return !isEmpty(this.colors)
    },
  },
}
